import React from 'react';
import { MyPATExpansionPanel, MyPATTextArea } from "../../../common";
import cx from "classnames";
import {
  Typography, Button, Grid,
} from '@material-ui/core';
import { Error } from "@material-ui/icons";
import MyPATBaseSection, { SectionFocusedContext, SectionFocusedContextValue } from '../../../common/MyPATBaseSection';
import MyPATUploader, { Attachment } from '../../../common/MyPATUploader';
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem } from '../../../common/MyPATUploadPreview';
import PDFViewer from './PDFViewer';
import DropZone from '../../../common/DropZone';
import { CREATE_NOTES_TABS } from '../../../../constants/comman';


const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
  "pdf"
];

interface CreateNotesProps {
  classes: any;
  editRights: string[],
  isError: Function,
  title: string,
  notesTitle: string,
  handleInputChange: Function,
  errorMessage: any,
  activeTab: string,
  setActiveTab: Function,
  pageState: any,
  addPageComponent: Function,
  handleAddPage: Function,
  setAttachments: Function,
  pdfFileAttachment: Attachment[],
  pdfPageData: any,
  pdfUrl: string;
  pdfType: string;
  onDocumentLoad: Function,
  handlePageChange: Function,
  password: Function,
  handleSelectChange: Function,
}

const CreateNotes = ({ classes, editRights, isError, title, notesTitle, handleInputChange, errorMessage
  , activeTab, setActiveTab, pageState, addPageComponent, handleAddPage, setAttachments, pdfFileAttachment,
  pdfPageData, pdfUrl, pdfType, onDocumentLoad, handlePageChange, password, handleSelectChange }:
  CreateNotesProps) => {

  return (
    <div className={classes.greyBgPanel}>
      <MyPATExpansionPanel
        isDisable={!editRights.includes('notes')}
        hasExpandIcon={false}
        variant="white"
        sectionId="createNotes"
        error={isError('title')}
        customCollapseTitle={
          <Typography variant="h6">
            Create Notes
          </Typography>
        }
        fullWidthControl
      >
        <div className={classes.notesTitle}>
          <label>Title <span className={classes.mandatory}>*</span></label>
          <MyPATTextArea
            name="title"
            value={title ? title : notesTitle}
            onChange={handleInputChange('title')}
            placeholder="Enter Notes Title"
            errorText={errorMessage.title}
            error={isError('title')}
            required
            fullWidthControl
          />
        </div>
        {/* <div>
            {errorMessage['title']? errorMessage['title']: ''}
            </div> */}
        <Grid item>
          <Grid className={classes.tabContainer}>
            {
              <span
                className={
                  activeTab === CREATE_NOTES_TABS.TYPE_NOTES
                    ? cx(
                      classes.cursorPointer,
                      classes.link,
                      classes.darkGrey,
                      classes.activeTabStyle,
                      classes.activeTabStyles
                    )
                    : cx(classes.link, classes.cursorPointer)
                }
                onClick={() => {
                  setActiveTab(CREATE_NOTES_TABS.TYPE_NOTES);
                }}
              >
                Type Notes&nbsp;
              </span>
            }
            &nbsp;&nbsp;
            {
              <span
                className={
                  activeTab === CREATE_NOTES_TABS.UPLOAD_PDF
                    ? cx(
                      classes.link,
                      classes.cursorPointer,
                      classes.darkGrey,
                      classes.activeTabStyle,
                      classes.activeTabStyles
                    )
                    : cx(classes.link, classes.cursorPointer)
                }
                onClick={() => {
                  setActiveTab(CREATE_NOTES_TABS.UPLOAD_PDF);
                }}
              >
                Upload a PDF&nbsp;
              </span>
            }
          </Grid>
        </Grid>
        {activeTab === CREATE_NOTES_TABS.TYPE_NOTES && <>
          {
            Object.keys(pageState).map((element: any, index: any) => {
              return addPageComponent(pageState[element], index);
            })
          }
          <>
            <div className={classes.addButtonAlign}>

              <Button
                variant="contained"
                color="primary"
                className={classes.addPageMore}
                onClick={() => handleAddPage()}
              >
                + Add Page
              </Button>
            </div>
          </>
        </>}
        {activeTab !== CREATE_NOTES_TABS.TYPE_NOTES && <>
          <SectionFocusedContext.Consumer>
            {({ setSectionFocus }: SectionFocusedContextValue) => (
              <MyPATBaseSection sectionId={`Upload PDF`} applyFocusedBorder={false} onFocusChange={setSectionFocus}>
                <Grid container className={classes.verticalSpace}>
                  <MyPATUploader
                    onChange={(data) => setAttachments(data)}
                    maxNoOfSelections={1}
                    allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                    initialAttachments={pdfFileAttachment}
                    maxFileSize={1024 * 1024 * 50} // 50 MB
                  >
                    {({
                      onItemRemove,
                      attachments,
                      loading,
                      errorMsg,
                      error,
                      handleFileChange,
                      multiple,
                    }) => {
                      const list = attachments.map((attachment) =>
                        convertFileOrUrlToPreviewItem(attachment)
                      );
                      return (
                        <Grid className={classes.attachFileContainer}>
                          <Grid container justify="flex-start" alignItems="center">
                            {/* Start: PDF Notes and Workbook Tab */}
                            <Grid item xs={12}>
                              <Grid className={classes.pdfWorkbook_Tab}>
                                <Typography className={"pwTab1 " + (pdfType !== 'WorkBook' ? ' activeTab' : '')} onClick={(e) => handleSelectChange(e)}>PDF Notes</Typography>
                                <Typography className={"pwTab2 " + (pdfType === 'WorkBook' ? ' activeTab' : '')} onClick={(e) => handleSelectChange(e)}>Workbook</Typography>
                              </Grid>
                            </Grid>
                            {/* End: PDF Notes and Workbook Tab */}
                          </Grid>
                          <Grid
                            container
                            alignItems="center"
                            className="uploadPreviewBox"
                          >
                            <MyPATUploadPreview
                              list={list}
                              readOnly={false}
                              onItemRemove={onItemRemove}
                              showPdfView={true}
                              pdfPageData={pdfPageData}
                              pdfType={pdfType}
                            />
                            {(attachments.length > 0 || pdfUrl) &&
                              <PDFViewer
                                url={attachments.length ? attachments[0] : pdfUrl}
                                password={password || ""}
                                onPageChange={handlePageChange}
                                onDocumentLoad={onDocumentLoad}
                              />
                            }
                            {error && (
                              <Grid item xs={12} justify="center">
                                <Typography
                                  className={classes.errorText}
                                  variant="caption"
                                  color="error"
                                >
                                  <Error />
                                  {errorMsg}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          {attachments.length === 0 &&
                            <DropZone onChange={handleFileChange}>
                              <Grid className="uploadPanel"
                              >
                                <Grid item>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    className="chooseFileBtn"
                                  >
                                    <label
                                      htmlFor="Order note attachments"
                                      className={classes.fileLabel}
                                    >
                                      <span className="attachmentIcon">
                                        <img src="/assets/svg/myLibrary/orderNotes/attachment-icon.svg" />
                                      </span>
                                      <span>&nbsp;&nbsp;Choose File</span>
                                    </label>
                                  </Button>
                                  <Grid className="buttonSubLabel">
                                    <Typography>or simply drop files here</Typography>
                                  </Grid>
                                  <span className={classes.fileInfo}>
                                    Only upload .pdf with max size 50 MB
                                  </span>
                                  <Grid>
                                    <input
                                      id="Order note attachments"
                                      aria-describedby="Add Order note attachments"
                                      type="file"
                                      onChange={handleFileChange}
                                      multiple={multiple || false}
                                      className={classes.inputFile}
                                      accept="application/pdf"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </DropZone>
                          }
                        </Grid>
                      );
                    }}
                  </MyPATUploader>
                </Grid>
              </MyPATBaseSection>
            )}
          </SectionFocusedContext.Consumer>
        </>}
      </MyPATExpansionPanel>
    </div>);
}


export default CreateNotes;